import request from "root/js/request";
const getStorageAndAcceptanceWarehouseDetailsTable = async ({
  wb_api_key_ids,
  date_from,
  date_to,
  category_id__in,
  brand_id__in,
  supplier_article__in,
  barcode__in,
  group_by,
  order_by,
  subject_id__in,
  product_id__in,
  limit,
  offset,
  q,
  ...rest
}) => {
  const response = await request({
    url: "/analytics/paid_storage_warehouse_detalization_table/",
    method: "get",
    params: {
      wb_api_key_ids,
      date_from,
      date_to,
      category_id__in,
      brand_id__in,
      supplier_article__in,
      barcode__in,
      group_by,
      order_by,
      subject_id__in,
      product_id__in,
      limit,
      offset,
      q,
      ...rest,
    },
  });
  return response.data;
};

export { getStorageAndAcceptanceWarehouseDetailsTable };
